import React from 'react';
import {
    Card,
    Chip,
    CardActionArea,
    CardContent,
    Typography, CardMedia, Box
} from "@mui/material";
import {CheckCircle} from '@mui/icons-material';
import {useSelector} from "react-redux";
import {getModuleTypeColor, modulePackageName} from "../../../../../utils/displayUtils";
import {MODULE_THUMBNAIL_LIST} from "../../../../../config/moduleThumbnails";
import ImageWithCredit from "../../../../common/ImageWithCredit";

export default function ModuleCard({moduleData, onSelect, isSelected, activeModuleIndex}) {
    const selectedTemplatesFromRedux = useSelector(state => state.template);

    const moduleInfo = MODULE_THUMBNAIL_LIST.find(img => img.moduleName === moduleData.name);
    const moduleImage = moduleInfo?.url || moduleData.image || '';
    const creditImage = moduleInfo?.credit || null;

    const handleCardClick = () => {
        const newSelectedState = !isSelected;
        onSelect({
            id: moduleData.id,
            name: moduleData.name,
            moduleType: moduleData.moduleType,
            image: moduleImage || moduleData.image,
            creditImage: creditImage || moduleData.image,
            isSelected: newSelectedState,
            templateId: selectedTemplatesFromRedux[activeModuleIndex],
            teoriEstimatedTime: moduleData.teoriEstimatedTime,
            testEstimatedTime: moduleData.testEstimatedTime,
            trainingEstimatedTime: moduleData.trainingEstimatedTime,
            totalTime: 0
        });
    };

// console.log('moduler', moduleData,)

    return (
        <Card sx={{width: 160, height: 200}}>
            <CardActionArea onClick={handleCardClick}>
                <ImageWithCredit
                    image={moduleImage || moduleData.image}
                    alt={moduleData.name}
                    creditImage={creditImage}
                />
                <CardContent>
                    <Typography sx={{fontWeight: 600, color: "#616161", mb: 1, fontSize: 13}}>
                        {moduleData.name}
                    </Typography>
                    <Chip label={`${modulePackageName(moduleData.moduleType)}`} sx={{
                        backgroundColor: `${getModuleTypeColor(moduleData.moduleType)}`,
                        color: '#fff',
                        fontSize: 11
                    }}/>
                </CardContent>
                {isSelected && (
                    <CheckCircle color="success" sx={{position: 'absolute', bottom: 5, right: 5}}/>
                )}
            </CardActionArea>
        </Card>
    );
}
